import { Component, Input, OnChanges, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { Observable } from 'rxjs';

// client (demo services)
// import { HttpClient } from "../services/client"
import { DemoService } from '../../../demo.service';


// interface (models)
// import { IUser } from "../services/interfaces"

import { FilterService, GridComponent, PageService, PdfExportService, SortService, ToolbarService } from '@syncfusion/ej2-angular-grids';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, DataUtil } from '@syncfusion/ej2-data';
import { FilterSettingsModel } from '@syncfusion/ej2-grids';

import { IFilter } from '@syncfusion/ej2-angular-grids';
import {
  ToolbarItems, GroupSettingsModel,
  RowDataBoundEventArgs
} from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';

import { IFilterUI } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { HotToastService } from '@ngneat/hot-toast';


import { SubjectNotes } from './../../../shared/models/subjectNotes.model';
import { inputs } from '@syncfusion/ej2-angular-dropdowns/src/drop-down-list/dropdownlist.component';
import { Notes } from './../../../shared/models/notes.model';
import { DomSanitizer } from '@angular/platform-browser';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';


@Component({
  selector: 'app-notes-grid',
  templateUrl: './notes-grid.component.html',
  styleUrls: ['./notes-grid.component.css']
})
export class NotesGridComponent implements OnInit {



  // passed Values.
  // setup as observable?
  @Input() item_id: Observable<any[]>; // impliments on changes. // Base set to Job_ID
  @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
  @Input() use_item_data?= false; // if data.model is sent use this instead of item_id

  @Input() item_user_level_id = null; // default to agent just in case
  @Input() item_brand_type_id = null;
  @Input() item_brand_id = null;
  @Input() item_subject_id?= null;
  @Input() item_subject_number?= null;

  @Input() show_buttons?= false; // yes | no
  @Input() item_title?= '';
  @Input() widget_size?= 'full'; // side | abstract | full

  @Input() job_id?: any;
  @Input() file_number = null; // subject file number
  @Input() reference_number = null; // subject file number


  @ViewChild('grid')
  public grid: GridComponent;

  public pageSettings: Object;
  public pageOptions = { pageSize: 100 };
  public filterOptions: FilterSettingsModel;
  public formatOptions: any;
  // public filterOptions: FilterSettingsModel;
  public filter: IFilter;
  public toolbarOptions: ToolbarItems[] | object;
  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;
  initialPage: { pageSize: number; };
  dateFormat: string;

  modalRef: BsModalRef;
  
  subject_id: number;
  model: {}; // put model for variables for sql where statements.
  subjectNote: SubjectNotes;
  notes: any;
  notes_table: any;
  notes_data: any;
  finalResult: any;
  array: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  show_agents: any[];
  agent_array: any;

  constructor(
    private _demoService: DemoService,
    private route: ActivatedRoute, private router: Router,
    public datepipe: DatePipe, public gfunc: GlobalFunctionsService,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
    private sanitizer: DomSanitizer,
    private modalService: BsModalService,
  ) {


// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

    // Setup Grid
    /*         this.toolbarOptions = [ 'Search', {
              text: '-',
              tooltipText: 'Submit Data to Send Agent Notifications', prefixIcon: 'e-test', id: 'Clic2k'
            }
            ]; */
    this.toolbarOptions = ['Search'];
    // this.toolbar = [
    // { text: 'Agent Update Request', tooltipText: 'Click', prefixIcon: 'e-expand', id: 'Click' }];
    //  this.initialPage = { pageSize: 100 };
    this.filterOptions = {
      type: 'Menu'
    };
    this.groupOptions = { columns: ['subject_number'] }; // sets auto grouping for the grid
    this.formatOptions = { type: 'date', format: 'dd/MM/yyyy' };
    this.dateFormat = 'dd/MM/yyyy hh:mm a';
    this.filter = { params: { format: this.dateFormat } };

  }


  // check for changes. to load data.
  ngOnChanges(changes) {
    if (changes.item_id) {
      // deal with asynchronous Observable result
      this.subject_id = changes.item_id.currentValue;
      // this.getJob(this.job_id);
      // this.getFiles();

      // console.log('so it does instigate here on changes');

      this.gfunc.current_base_route = this.router.url.substr(0, this.router.url.lastIndexOf('/'));

      // put model.
      this.model = {
        subject_id: this.subject_id,
        // brand_id: this.item_brand_id, 
        brand_type_id: this.item_brand_type_id, // show files only related to login brand. client | owner | agent
        subject_number: this.item_subject_number,
        file_number: this.file_number,
        reference_number: this.reference_number,
        job_id: this.job_id,
        brand_id: this.item_brand_id,
      };
      // console.log(JSON.stringify(this.model));
      this.getSubjectNotesGrid(this.model); // Put Event instead of Get?? Do I get a response of data?// use for all jobs

      // this.getSubjectNotesProgressionTable(this.job_id, this.file_number);
    }


    if (changes.item_data) {

    }
  }


  ngOnInit() {
    // this.getFiles();
    // Moved to observables.
  }


  getSubjectNotesGrid(model) {
    this.notes = [];
    this.show_agents = [];
    this._demoService.getSubjectNotesGrid(model).subscribe(
      data => { this.notes_data = data;
        // this.notes = data;
        this.notes_table = this.notes_data.slice(0, 10);


// array for agents display test may not be correct if other agents?
let newArrA = data;
//  let  count_of_items = Object.keys(newArrA).length;
let  count_of_items = Object.keys(newArrA).length;
   // need to do a loop of subject_billing items (.length)
   for(let i=0;i < count_of_items; i++) {
   let res22 = newArrA[i];

   // just grabs the first agent. // as pass was throwing errors. // end of json.
   this.agent_array = JSON.stringify(res22.assigned_to_agents);

  //  this.show_agents.push({
  //    recipient_name: res.recipient_name + '',
  //    recipient_email_address: res.recipient_email_address,
  //    recipient_brand_id: res.recipient_brand_id,
  //    recipient_subject_id: res.subject_id,
  //    recipient_brand_type_id: res.brand_type_id,
  //    recipient_user_id: null,
  //    recipient_user_level_id: null,
  //    recipient_type_name: 'Agent',
  //  });
   } // end for loop
//  this.show_agents = this.show_agents; // ?? this may be causing errors.
this.show_agents = this.agent_array; // ?? this may be causing errors.



// new sysetm to filter only notes for agents views.
if (this.gfunc.sessionUserLevel == 5) {
console.log('Agent Login Detected: ', this.gfunc.sessionBrandName);
// need to filter the results if exists in the assinged_to_agents array, create a new note array
let array = [];
let ata_array = [];
// tslint:disable-next-line:max-line-length
// && sbi.brand_type_id === this.gfunc.sessionBrandTypeId  // can add for extra security layer to ensure.???
let newArr = Object(data).filter((sbi)=>(sbi.assigned_to_agents !== '[]' )); // User this if filter is needed.
// let newArr = data;
let  count_of_items = Object.keys(newArr).length;
  // need to do a loop of subject_billing items (.length)
  for(let i=0;i < count_of_items; i++) {
    let res = newArr[i];
    // ned to see if exists in array if so push to notes array.

    
    // array = res.assigned_to_agents;
  // stop errors on filter if empty

array = JSON.parse(res.assigned_to_agents);
// console.log('array: ', array);
if (res.assigned_to_agents == '(NULL)'){
  // set incase database has a null value to stop errors occurning on fulters
  array = [];
}

  //  if (array.length >= 1) {    }

     ata_array = array.filter( (n: any) => (
        n.recipient_brand_id === this.gfunc.sessionBrandId
        // n.note_id >= '200'
        // && sbi.subject_id === this.subject_service_metrix_search_full_results[i].subject_id
        ));
 


// console.log('ata_array: ', JSON.stringify(res.ata_array));
// console.log('ata_array.lenght: ', ata_array.length);

// console.log('assigned_to_agents: ', JSON.stringify(res.assigned_to_agents));

// only add if exsists in array
if (ata_array.length === 1) {
  this.notes.push({
  ...newArr[i]
  });
} // end if array.lenght

} // end for loop

this.notes_table = this.notes.slice(0, 10);
// console.log('Filtered Agent Notes: ', JSON.stringify(this.notes));
if (this.widget_size == 'full') {
this.grid.refresh();
}
// this.allRecipients = this.allRecipients; // ?? this may be causing errors.







// filters the notes and checks if the current agent brand id exists in the array
// tslint:disable-next-line:max-line-length
          // this.notes = this.notes_data.filter( (n: any) => (
          //   n.assigned_to_agents[0].recipient_brand_id === this.gfunc.sessionBrandId
          
          //   // n.note_id >= '200'
          //   // && sbi.subject_id === this.subject_service_metrix_search_full_results[i].subject_id
          //   ));

          // console.log('Filtered Agent Notes: ', JSON.stringify(this.notes));
console.log('Current Brand ID: ', this.gfunc.sessionBrandId);

      // let newArr = Object(data).filter((sbi)=>(
      //   sbi.assigned_to_agents != '[]'
      //   && sbi.assigned_to_agents.recipient_brand_id === this.gfunc.sessionBrandId
      //   )); // User this if filter is needed.
      // // let newArr = data;

      // let  count_of_items = Object.keys(newArr).length;
      //   // need to do a loop of subject_billing items (.length)
      //   for(let i=0;i < count_of_items; i++) {
      //   let res = newArr[i];
      //   this.notes.push({
      // ...newArr[i],
      //   });
      //   } // end for loop
      // // this.notes = this.notes; // ?? this may be causing errors.
      //   console.log('Filtered Agent Notes: ', JSON.stringify(this.notes));
      // this.grid.refresh();



      // :: Filter object inside an object - using findIndex.
      // @https://stackoverflow.com/questions/43405841/filtering-json-object-on-an-object-inside-an-object
      // group3Items = items.filter(item => item.groups.includes(group => group.id==3))

      // tslint:disable-next-line:max-line-length
      // let group3Items =  this.notes_data.filter(item => item.assigned_to_agents[0].findIndex(group => group.recipient_brand_id==this.gfunc.sessionBrandId) > -1);

      //       let group3Items = this.notes_data.filter(
      //         item => item.assigned_to_agents !== '[]'
      //         && item.assigned_to_agents.includes(assigned_to_agents => assigned_to_agents.recipient_brand_id === '99')
      //         );
      // this.notes = group3Items;
      //       console.log('Filtered Agent Notes: ', JSON.stringify(this.notes));
      // this.grid.refresh();



      // new function that does the magic
      // this.transform(JSON.stringify(this.notes), this.gfunc.sessionBrandId);
}else {
  //  this.notes = data; // activated so clients can see notes
} // end if agent logged in.

// fix for client notes needing a filter. (notes have a brand_id)


if (this.gfunc.sessionUserLevel == 9) {
  this.notes = []; // empty the array first
  // sbi.file_brand_id === this.gfunc.sessionBrandId ||
  let newArr = Object(data).filter((sbi)=>(
    sbi.brand_id === this.gfunc.sessionBrandId && sbi.brand_type_id === 'Client'
    )); // User this if filter is needed.
  // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
//  this.notes = DataUtil.parse.parseJson(newArr);
 this.notes = newArr;
// this.notes = data; // activated so clients can see notes
this.notes_table = newArr.slice(0, 10);
     
  } // end if agent logged in.


        // console.log("Done loadng USER");
        // console.log(this.users);
      },
      error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
      }
    );
  }


// :: @https://stackoverflow.com/questions/55097240/how-to-filter-json-object-array-across-nested-array-with-in-it
// :: @https://stackblitz.com/edit/angular-uzgni7?file=src%2Fapp%2Fapp.component.ts

  transform(array: any, valueToSearch: string): any[] {
    return  array.filter(e => {
        e.assigned_to_agents.filter(ee => {
          if(ee.recipient_brand_id === valueToSearch ) {
            console.log(e);
            this.finalResult = e;
            this.notes = e;
            this.grid.refresh();
          }
        });
      });
  }



  getSubjectNotesProgressionTable(job_id, file_number,model) {
    this._demoService.getSubjectNotesProgressionTable(job_id, file_number, model).subscribe(
      data => {
        this.notes = data;
        this.notes_table = this.notes.slice(0, 10);

        // console.log("Done loadng USER");
        // console.log(this.users);


      },
      error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
      }
    );
  }


  deleteSubjectNote(note_id) {
    if (confirm('Are you sure you want to delete this note? ')) {
      this._demoService.deleteSubjectNote(note_id).subscribe(
         data => {
          this.refreshGrid();
         },
         error => {
           console.error('Error deleting Trace Candidate Note!');
          return console.log(error);
         }
      );
  }
  }


  // nSome grid functions

  toolbarClick(args: ClickEventArgs): void {
    if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
    }
  }
  rowDataBound(args: RowDataBoundEventArgs) {
    const job_status = 'job_status';
    if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
    }
  }


  clickHandler(args: ClickEventArgs): void {
    if (args.item.id === 'Click') {

      //  this.grid.showSpinner();

      //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
      //  console.log(args.data.items);



      let pdfdata;
      const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
      for (let i = 0; i < query.queries.length; i++) {
        if (query.queries[i].fn === 'onPage') {
          query.queries.splice(i, 1);       // remove page query to get all records
          break;
        }
      }
      const fdata = new DataManager({ json: this.notes }).executeQuery(query).then((e: any) => {
        pdfdata = e.result as object[];  // get all filtered records
        const exportProperties = {
          dataSource: pdfdata,
        };
        // console.log(pdfdata.results);

        // this.search_results = pdfdata.records; // need this if a grouping is set.
        /*     this.search_results = pdfdata;
            this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
            this.toastr.success( "Press Start To Process Que");  */
        // this.grid.pdfExport(exportProperties);
      }).catch((e) => true);
    }

    //  this.grid.hideSpinner();

  }

  clientSubjectEditLink(subject_id) {
    this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + '']);
  }


  clientViewSystemFile(file_id) {
    this.router.navigate(['/admin/system-file-manager/system-file/' + file_id + '']);
  }


  refreshGrid() { // refresh the databutton
    // this.getFiles();
    this.getSubjectNotesGrid(this.model);
    this.grid.refresh();
  };

  refreshTable() { // refresh the databutton
    // this.getFiles();
    this.getSubjectNotesGrid(this.model);
    // this.grid.refresh();
  };

  getHtml(html){
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }


// MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
 }
 
 // :: Parent / Child modal test
 closeParentModel() {
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
 //  this.updateTypeClick = false; // closes the div
 // :: reset the entire page.
 this.gfunc.globalJobViewSkipRoute(this.job_id);
 };
 


}
